<template>
  <!--大图样式-->
  <div
    v-if="(advName === 'like_0' || advName === 'like_2') && showAd"
    class="bigpic-ad sr-adv"
    :data-mid="mid"
    :data-tplid="tplid"
    :data-name="advName"
    :data-w="w"
    :data-h="h"
    data-vis="0"
  >
    <template v-if="bigdata">
      <a
        :href="bigdata[0].link"
        :uigs="'iadv_' + advName"
        @mousedown="cl(bigdata[0])"
      >
        <div class="default-error-img">
          <img
            :src="checkHttps(bigdata[0].imglist[0])"
            alt
          >
        </div>
        <div class="bigpic-ad-txt">
          <p class="bigpic-ad-txt-title">{{ bigdata[0].title }}</p>
          <p class="bigpic-ad-txt-ad"><span>广告</span></p>
        </div>
      </a>
      <button @click="showAd = false" />
    </template>
  </div>
  <!--左图右文 -->
  <div
    v-else-if="advName === 'midAdv' && showAd"
    class="sr-adv"
    :data-mid="mid"
    :data-tplid="tplid"
    data-vis="0"
    :data-name="advName"
    :data-w="w"
    :data-h="h"
  >
    <template v-if="bigdata">
      <a
        class="sr-adv-lprt"
        :href="bigdata[0].link"
        :uigs="'iadv_' + advName"
        @mousedown="cl(bigdata[0])"
      >
        <div class="sr-adv-lprt-info">
          <h4>{{ bigdata[0].title }}</h4>
          <p>
            <span>广告</span>
            <span>{{ bigdata[0].client }}</span>
          </p>
        </div>
        <div class="default-error-img sr-adv-lprt-img">
          <img
            :src="checkHttps(bigdata[0].imglist[0])"
            alt
          >
        </div>
      </a>
    </template>
  </div>
  <!--播放源补足广告位-->
  <div
    v-else-if="advName === 'relative' && showAd"
    class="sr-adv"
    :data-mid="mid"
    :data-tplid="tplid"
    data-vis="0"
    :data-name="advName"
    :data-w="w"
    :data-h="h"
  >
    <template v-if="bigdata">
      <a
        :href="bigdata[0].link"
        :uigs="'iadv_' + advName"
        @mousedown="cl(bigdata[0])"
      >
        <div class="sr-adv-relative-img">
          <div class="default-error-img">
            <img
              :src="checkHttps(bigdata[0].imglist[0])"
              alt=""
            >
          </div>
          <span class="sr-adv-tag-ad">广告</span>
        </div>
        <div class="sr-adv-relative-info">
          <p>{{ bigdata[0].title }}</p>
        </div>
      </a>
    </template>
  </div>
</template>

<script>
import 'intersection-observer';

import axios from 'axios';

import { checkHttpsUrl } from '../js/util';

export default {
  name: 'ExtAdv',
  props: {
    advName: {
      type: String,
      default: '',
    },
    mid: {
      type: String,
      default: '',
    },
    tplid: {
      type: String,
      default: '',
    },
    w: {
      type: String,
      default: '',
    },
    h: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      oD: null,
      domName: this.advName,
      bigdata: '',
      showAd: true,
    };
  },
  mounted() {
    this.observeDom();
  },
  methods: {
    checkHttps(url) {
      return checkHttpsUrl(url);
    },
    async sendRequest(opt) {
      const url = `/napi/adv?${this.myStringify(opt)}`;
      const data = await axios
        .get(url, { timeout: 3000 })
        .then(res => res.data)
        .catch(() => '');
      return data;
    },
    observeDom() {
      const dom = document.querySelectorAll(`.sr-adv[data-name='${this.domName}'][data-vis='0']`);
      const self = this;
      if (!this.oD) {
        this.oD = new IntersectionObserver(async (entries) => {
          for (const item of entries) {
            if (item.isIntersecting) {
              item.target.dataset.vis = '1';
              const { mid, tplid, w, h } = item.target.dataset;
              const { title } = document;
              let data = await self.sendRequest({ mid, tplid, w, h, title });
              data = data.data;
              if (data && data.status === 0) {
                if (data.adinfo && data.adinfo.length > 0) {
                  self.bigdata = data.adinfo;
                  const { iurl } = data.adinfo[0];
                  if (iurl) {
                    self.ping(iurl);
                  }
                }
              } else {
                self.showAd = false;
              }
              self.oD.unobserve(item.target);
            }
          }
        });
      }

      for (const d of dom) {
        this.oD.observe(d);
      }
    },
    myStringify(obj) {
      let queryStr = '';
      const queryArr = [];

      Object.keys(obj).forEach((key) => {
        queryArr.push(`${key}=${encodeURIComponent(obj[key])}`);
      });

      queryStr = queryArr.join('&');
      return queryStr;
    },
    cl({ curl }) {
      if (curl) {
        this.ping(curl);
      }
    },
    ping(url) {
      new Image().src = url;
    },
  },
};
</script>

<style scoped lang="scss">
.default-error-img:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  background: url(https://dlweb.sogoucdn.com/resource/web/dist/static/img/img-error.9d3fe219.png) no-repeat center;
  z-index: -1;
}
.bigpic-ad {
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  height: 192px;
  margin-bottom: 27px;

  img {
    width: 100%;
    height: 100%;
  }
}
.bigpic-ad button {
  border: none;
  width: 24px;
  height: 24px;
  position: absolute;
  right: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
}
.bigpic-ad button:before {
  content: '';
  width: 1px;
  height: 14px;
  background: #fff;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.bigpic-ad button:before,
.bigpic-ad button:after {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.bigpic-ad button:after {
  content: '';
  width: 1px;
  height: 14px;
  background: #fff;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.bigpic-ad button:before,
.bigpic-ad button:after {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.bigpic-ad .bigpic-ad-txt {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  max-height: 57px;

  .bigpic-ad-txt-title {
    font-size: 15px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    /*! autoprefixer: ignore next */
    -webkit-box-orient: vertical;
    line-height: 19px;
    color: #fff;
    max-width: 87%;
    margin-left: 12px;
    padding: 6px 0;
  }
}
.bigpic-ad-txt-ad {
  width: 24px;
  height: 15px;
  border-radius: 3px;
  opacity: 0.5;
  border: 1px solid rgba(255, 255, 255, 1);
  position: absolute;
  bottom: 6px;
  right: 6px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 9px;
    color: rgba(255, 255, 255, 1);
  }
}
.sr-adv-lprt {
  margin-top: -10px;
  padding: 0px 14px 30px 14px;
  display: flex;
}
.sr-adv-lprt-img {
  position: relative;
  z-index: 0;
}
.sr-adv-lprt img {
  border-radius: 3px;
  flex: none;
  display: block;
  width: 132px;
  height: 74px;
  border-radius: 3px;
  position: relative;
}
.sr-adv-lprt .sr-adv-lprt-info {
  align-items: flex-start;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin-right: 6px;
  flex: 1;
}
.sr-adv-lprt-info h4 {
  font-size: 15px;
  color: rgba(0, 0, 0, 1);
  line-height: 21px;
  font-weight: normal;
  overflow: hidden;
  line-height: 25px;
  text-overflow: ellipsis;
  word-wrap: normal;
  -webkit-line-clamp: 2;
  display: block;
  display: -webkit-box;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}
.sr-adv-lprt-info p {
  font-size: 13px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 13px;
  margin-top: 9px;
}

.sr-adv-relative-img {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.47059%;
  border-radius: 5px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
  }
}
.sr-adv-relative-info p {
  margin-top: 7px;
  font-size: 15px;
  color: #222;
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: normal;
  -webkit-line-clamp: 2;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  display: block;
  display: -webkit-box;
}
.sr-adv-tag-ad {
  position: absolute;
  display: block;
  right: 6px;
  bottom: 6px;
  border-radius: 3px;
  color: #fff;
  border: 1px solid #fff;
  font-size: 9px;
  padding: 3px;
  z-index: 2;
}
</style>
